// [Deprecated] Use app/components/modal/component.rb and the associated controller
// instead of layout modal + this controller
import { Controller } from "@hotwired/stimulus"
import "@hotwired/turbo-rails";

export default class extends Controller {
  static values = { scriptOnClose: String, scrollTo: String }

  connect() {
    const modal = $(this.element).find(".modal")

    if (this.scrollToValue) {
      modal.one("shown.bs.modal", () => {
        modal.find(this.scrollToValue)[0]?.scrollIntoView({ block: "end" })
      })
    }

    modal.modal("show")

    if (this.scriptOnCloseValue) {
      modal.on('hide.bs.modal', () => {
        try {
          eval(this.scriptOnCloseValue)
        } catch (e) {
          console.log(e)
        }
      })
    }

    document.addEventListener("turbo:before-cache", this.removeBeforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.removeBeforeCache)
    $(this.element).find(".modal").modal("hide")
    $(".modal-backdrop").remove()
  }

  // The modal stays in the DOM after being dismissed, so it gets captured in
  // Turbo's page snapshot and connect() re-opens it on a restore visit
  // (browser back).
  removeBeforeCache = () => {
    this.element.remove()
  }
}
